import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/ventures/save`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetAllAgents: `${endpointBackend}gci/agents/getall`,
        endpointGetAllUsers: `${endpointBackend}gci/users/getall`,
        endpointGetById: `${endpointBackend}gci/ventures/getById`,
        endpointGetAllVentures: `${endpointBackend}gci/ventures/getall`,
        urlGoBack: `/gci/ventures/list`,
        pathView: `/gci/ventures/view`
    }

    const labels = {
        labelTitleAdd: "Novo Empreendimento",
        labelTitleEdit: "Editar Empreendimento",
        labelTitleView: 'Visualizar Empreendimento'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_project_id = null;
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: values.gci_company_id
                            }
                        },
                    },
                    validations: {
                        required: true,
                        projectHasVenture: true
                    },
                    columnSize: 12
                },
                {
                    name: 'document_type',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [
                        { label: 'CPF', value: 'CPF' },
                        { label: 'CNPJ', value: 'CNPJ' },
                    ],
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.document = '';
                        const form = getForm(values);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 6
                },
                {
                    name: 'document',
                    type: values.document_type,
                    label: values.document_type,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'enterprise_name',
                    type: 'text',
                    label: 'Nome do Empreendimento',
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'gci_agent_id',
                    type: 'select',
                    label: 'Representante do Empreendimento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAgents,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: values.gci_company_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'approval_protocol_number',
                    type: 'text',
                    label: 'Protocolo de Aprovação - Prefeitura',
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                },
                {
                    name: 'approval_alvara_number',
                    type: 'text',
                    label: 'Numero do Alvará de Aprovação',
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                },
                {
                    name: 'possession',
                    type: 'textarea',
                    label: 'Posse',
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCities,
                        label: 'city_name',
                        value: 'city_id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    autocomplete: true,
                    hasComplement: true
                },
                {
                    name: 'obs',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                }
            ],
            customValidators: {
                projectHasVenture: async (value, options, key, attributes) => {
                    const ventures = await Fetch.post(paths.endpointGetAllVentures, {
                        filter: {
                            gci_project_id: value
                        }
                    });

                    if (ventures.length > 0 && !id) {
                        return '^Já existe um empreendimento cadastrado para este projeto.';
                    }

                    return '';
                }
            },
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            values.document_type = values.document_type || 'CPF';

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
